import { useTranslation } from 'react-i18next'
import { Button, EditIcon, Text, TruckIcon } from '@mercai/clever'
import { formatLongDate, isSaleOrderEditable } from '@/helpers'

import { CardInfo } from '@/components'

import styles from './card-order-logistic-transport-option.module.css'

import type { CardOrderLogisticTransportOptionProps } from './card-order-logistic-transport-option.type'

export const CardOrderLogisticTransportOption = ({
  isLoading,
  shipment,
  onEdit,
  saleOrderStatus,
}: CardOrderLogisticTransportOptionProps) => {
  const { t } = useTranslation('componentCardsOrderCenterShow')

  const isEditable = isSaleOrderEditable(saleOrderStatus)

  const objects = {
    pick_up: [
      {
        label: t('orderLogisticShipmentTransportOptionSelectedDeliveryDate'),
        value: shipment?.transportOptions?.customerSelectedDeliveryDate
          ? formatLongDate(
              shipment.transportOptions.customerSelectedDeliveryDate,
            )
          : '-',
      },
      {
        label: t('orderLogisticShipmentTransportOptionSelectedDeliveryPeriod'),
        value: shipment?.transportOptions?.customerSelectedDeliveryPeriod
          ? shipment.transportOptions.customerSelectedDeliveryPeriod ===
            'morning'
            ? '9:00 AM - 12:00 PM'
            : '12:00 PM - 05:00 PM'
          : '-',
      },
      {
        label: t('orderLogisticShipmentTransportOptionDriver'),
        value: shipment?.transportOptions?.driver || '-',
      },
      {
        label: t('orderLogisticShipmentTransportOptionCompany'),
        value: shipment?.transportOptions?.transportCompany || '-',
      },
      {
        label: t('orderLogisticShipmentTransportOptionPlate'),
        value: shipment?.transportOptions?.vehicleIdentifier || '-',
      },
      {
        label: t('orderLogisticShipmentTransportOptionTypeVehicle'),
        value: shipment?.transportOptions?.vehicleType || '-',
      },
    ],
    receive_at_address: [
      {
        label: t('orderLogisticShipmentTransportOptionPickUpName'),
        value: shipment?.transportOptions?.driver || '-',
      },
      {
        label: t('orderLogisticShipmentTransportOptionCompany'),
        value: shipment?.transportOptions?.transportCompany || '-',
      },
      {
        label: t('orderLogisticShipmentTransportOptionTypeVehicle'),
        value: shipment?.transportOptions?.vehicleType || '-',
      },
      {
        label: t('orderLogisticShipmentTransportOptionPlate'),
        value: shipment?.transportOptions?.vehicleIdentifier || '-',
      },
      {
        label: t('orderLogisticShipmentTransportOptionTrackingInfo'),
        value: shipment?.transportOptions?.trackingInfo ? (
          <Text
            variant="link"
            href={shipment?.transportOptions?.trackingInfo}
            target="_blank"
            className={styles.link}
          >
            {t('orderLogisticShipmentTransportOptionTrackingInfoClick')}
          </Text>
        ) : (
          '-'
        ),
      },
    ],
  }

  return (
    <div className={styles.core}>
      <CardInfo
        isLoading={isLoading}
        icon={<TruckIcon />}
        title={
          shipment?.deliveryOption === 'pick_up'
            ? t('orderLogisticShipmentPickUp')
            : t('orderLogisticShipmentReceiveAtAddress')
        }
        items={objects[shipment?.deliveryOption || 'pick_up']}
        actions={
          isEditable &&
          onEdit && (
            <Button
              size="small"
              variant="ghost"
              className={styles.edit}
              onClick={onEdit}
            >
              {t('editLabel')}
              <EditIcon />
            </Button>
          )
        }
      />
    </div>
  )
}
